export default __webpack_public_path__ + "static/media/nazgul.8f876aa5.png";